import React from 'react'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import GenericModal from './GenericModal/GenericModal'
import { getFullPath } from 'lib/location'
import { closeModal } from 'lib/utils/store/modals'

/**
 * ControlledModal Component
 *
 * A controlled modal component that provides an interface for displaying content in a modal dialog.
 * This component can be opened or closed based on external state, making it ideal for usage in scenarios where modal visibility is controlled by the parent component.
 */

const ControlledModal = ({
    onClose,
    name,
    disableBackdropCloseClick,
    routedModal,
    closeOnRouteChange,
    ...rest
}) => {
    const history = useHistory()
    const location = useLocation()

    const handleClose = (name) => {
        if (!routedModal) {
            closeModal(name)
        } else {
            history.push(getFullPath(location, { hash: false }))
        }

        onClose && onClose(name)
    }

    if (routedModal && closeOnRouteChange) {
        console.warn('routedModal && closeOnRouteChange should not be true at the same time')
    }

    return (
        <GenericModal
            name={name}
            onClose={handleClose}
            disableBackdropCloseClick={disableBackdropCloseClick}
            {...rest}
        />
    )
}

ControlledModal.propTypes = {
    context: PropTypes.string.isRequired,
    disableBackdropCloseClick: PropTypes.bool,
    routedModal: PropTypes.bool,
    initialTitle: PropTypes.string,
}

export default ControlledModal
